module.exports = __webpack_public_path__ + "media/images/gmail-3b43afff941649788604a408ae159998.png";